<template>
  <v-btn text @click="download">
    <v-icon class="mr-2">mdi-cloud-download</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  props: ["label", "url", "filename", "data"],
  methods: {
    download() {
      this.loading = true;

      this.$store
        .dispatch(this.url, this.data)
        .then(datas => this.forceFileDownload(datas))
        .finally((this.loading = false));
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>
